import { defineStore } from "pinia"
import { ref, computed } from "vue"
import type { AttackContext } from "~/types"

export const useAttackContextStore = defineStore(
  "attackContext",
  () => {
    // State
    const attackContext = ref<AttackContext>({
      attackType: "Ranged",
      melee: {
        attackerCharged: false,
      },
      ranged: {
        defenderInCover: false,
        remainedStationary: false,
        withinHalfRange: false,
      },
    })

    // Getters
    const attackContextCount = computed(() => {
      const active = {
        melee: 0,
        ranged: 0,
      }
      const total = {
        melee: 0,
        ranged: 0,
      }

      const melee = attackContext.value.melee
      const ranged = attackContext.value.ranged

      Object.values(melee).forEach((value) => {
        total.melee++
        if (value) {
          active.melee++
        }
      })

      Object.values(ranged).forEach((value) => {
        total.ranged++
        if (value) {
          active.ranged++
        }
      })

      return {
        active,
        total,
      }
    })

    // These getters handle the difference between ad hoc & profile input.
    const getAttackContextForSim = computed(() => {
      return (profileUiAttacker: string) => {
        if (profileUiAttacker === "adhoc") {
          // Override attack context as though it is ranged.
          return {
            attackType: "Ranged" as const,
            melee: {},
            ranged: {
              ...attackContext.value.ranged,
            },
          }
        }
        return attackContext.value
      }
    })

    return {
      attackContext,
      attackContextCount,
      getAttackContextForSim,
    }
  },
  {
    persist: {
      key: "unitcrunch-attackContext",
      storage: piniaPluginPersistedstate.localStorage(),
    },
  }
)
